import { formatTimeLeft, isTimeLeftWarning } from '../models/types';
import { colors } from '../theme';

/**
 * "1 h 12 m left" for a hunt; coral with a "⏳ " prefix in its last hour.
 * Renders nothing when the hunt has no `expiresAt` or has already run out.
 */
export function TimeLeftLabel({ expiresAt, now }: { expiresAt: number | null; now: number }) {
  if (expiresAt == null || expiresAt <= now) return null;
  const remaining = expiresAt - now;
  const warning = isTimeLeftWarning(remaining);
  return (
    <span className="t-label" data-testid="time-left" data-warning={warning} style={warning ? { color: colors.coral } : undefined}>
      {warning ? '⏳ ' : ''}
      {formatTimeLeft(remaining)}
    </span>
  );
}
